import comp from "./CriteriaRubricAssessmentWrapper";
export default comp;
